import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

/**
 * Get a predicate element from store by ID
 * @param {string} id
 * @returns object | null
 */
export const usePredicateStorePredicates = (ids = []) => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);

    return ids.map((id) => predicates?.[id]);
};
